import { environment } from "../../env/env.constants";
const NO_AUTH_TOKEN = "";

const devNoToken = () => {
  return "";
};

const prodJWTToken = async () => {
  return "JWT " + window.AP ? await window.AP.context.getToken() : NO_AUTH_TOKEN;
};

export const getAuthorizationToken = async () => {
  return process.env.NODE_ENV === environment.DEVELOPMENT ? devNoToken() : prodJWTToken();
};
